// extracted by mini-css-extract-plugin
export var printerCard = "_ez-1";
export var printerCardConfigured = "_ez-2";
export var printerCardError = "_ez-3";
export var printerCardsContainer = "_ez-0";
export var printerIcon = "_ez-8";
export var printerIconConfigured = "_ez-5";
export var printerIconContainer = "_ez-4";
export var printerIconError = "_ez-6";
export var printerIconUnconfigured = "_ez-7";
export var workstationsTableCard = "_ez-9";